'use client'

import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { walletConnectionQueueAtom } from '@/src/stores/accounts/detection'
import {
  focusedAccountAtom,
  hasAddedWalletAtom,
  newlyAddedWalletNameAtom,
} from '@/src/stores/accounts/wallets'
import {
  closeSelectWalletsDialog,
  selectWalletsDialogAtom,
  selectWalletsDialogChainTypeAtom,
} from '@/src/stores/select-wallets'
import { ConnectWalletsDialog } from './connect-wallets-dialog'

export function ConnectWalletDialog() {
  const [dialogState, setDialogState] = useAtom(selectWalletsDialogAtom)
  const chainType = useAtomValue(selectWalletsDialogChainTypeAtom)

  const walletConnectionQueue = useAtomValue(walletConnectionQueueAtom)
  const setNewlyAddedWalletName = useSetAtom(newlyAddedWalletNameAtom)
  const setHasAddedWallet = useSetAtom(hasAddedWalletAtom)
  const setFocusedAccount = useSetAtom(focusedAccountAtom)

  // Always use the accounts-based connect wallet dialog
  return (
    <ConnectWalletsDialog
      open={dialogState.open}
      onOpenChange={(open) => {
        /**
         * Need to flush the newly added wallet name, has added first wallet state, and focused account state
         * to ensure no state is left over when the dialog is closed
         */
        if (!open) {
          // BLOCK dialog close if wallet connection is in progress
          // This prevents race condition where dialog closes before accounts are auto-added
          if (walletConnectionQueue.size > 0) {
            return // Don't close the dialog yet, connection still in progress
          }

          setNewlyAddedWalletName(null)
          setHasAddedWallet(false)
          setFocusedAccount(null)
        }
        setDialogState(
          open ? { open: true, chainType } : closeSelectWalletsDialog(),
        )
      }}
      chainType={chainType}
    />
  )
}
